<template>
  <div class="menu" v-bind:class="[ classe ]">
      <hider :initiallyVisible="true" prefixOn="" prefixOff="">
	<template v-slot:always>
      <div class="ops">
          <button type="button" @click="raz" title="reset"><i class="fa fa-undo"></i>zero</button>
          <button type="button" @click="dup" title="clone"><i class="fa fa-copy"></i>copy</button>
          <button type="button" @click="kill" title="kill"><i class="fa fa-trash"></i>kill</button>
          <button type="button" @click="setOffert" title="offrir">
           {{ menu.offert ? "🎁🎁🎁" : "offrir?" }}
          </button>
          <input class="nom" placeholder="nom" v-model="menu.nom">
      </div>
      </template>
      <template v-slot:label>
       <div class="header" v-bind:class="[ classe ]">
         <span>{{ idx }}.</span>
         &nbsp;
         <span>Menu {{ classe | capitalize }} : {{ menu.offert ? "Offert" : total() + "€" }} {{ maybeNom }}</span>
       </div>
      </template>
      <MultiCount :list="Object.entries(menu.viandes)"
                  :view="getNom"
                  :keyer="getNom"
                  :cb="setc('viandes')"
                  @set-viande="setViande">
        <template v-slot:top><p class="sep">viandes ({{menu.viandes.length}})</p></template>
      </MultiCount>
      <multiset :init="menu.pain" :list="pain" :view="getNom" :keyer="getNom"
                :cb="setc('pain')">
        <template v-slot:top><p class="sep">pain</p></template>
      </multiset>
      <multiset :init="menu.sauces" :list="sauce" :view="getNom" :keyer="getNom"
                :cb="setc('sauces')">
        <template v-slot:top><p class="sep">sauces</p></template>
      </multiset>
      <multiset :init="menu.condiments" :list="condiment" :view="getNom" :keyer="getNom"
                :cb="setc('condiments')">
        <template v-slot:top><p class="sep">condiments</p></template>
      </multiset>
      <multiset :init="menu.legumes" :list="legume" :view="getNom" :keyer="getNom"
                :cb="setc('legumes')">
        <template v-slot:top><p class="sep">legumes</p></template>
      </multiset>
      <multiset :init="menu.fromages" :list="fromage" :view="getNom" :keyer="getNom"
                :cb="setc('fromages')">
        <template v-slot:top><p class="sep">fromages</p></template>
      </multiset>
      <multiset :init="menu.bobos" :list="bobo" :view="getNom" :keyer="getNom"
                :cb="setc('bobos')">
        <template v-slot:top><p class="sep">bobos</p></template>
      </multiset>
      <boisson v-for="(cb, b) in menu.boissons" :key="b" :cb="cb" @set-boisson="setBoisson">
      </boisson>
    </hider>
  </div>
</template>

<script>

import * as Menu from '@/models/menu.js'
import { viande, sauce, pain, condiment, legume, fromage, bobo, boisson, } from '@/models/model.js'
import Boisson from '@/components/menu/Boisson.vue'
import Multiset from '@/components/base/Multiset.vue'
import MultiCount from '@/components/base/MultiCount.vue'
import Hider from '@/components/base/Hider.vue'

const oneCap = s => s.charAt(0).toUpperCase()
const twoCap = s => (([a,b]) => a.toUpperCase() + b)(s.slice(0,2));

export default {
    components: { Boisson, Multiset, Hider, MultiCount, },
    props: {
      menu : { type: Object, required: true },
      idx : { type: Number, required: true },
      set : { type: Function, required: true },
    },
    data() {
      return {
          debugData    : false,
          viande,
          sauce,
          pain,
          condiment,
          legume,
          fromage,
          bobo,
          boisson,
      };
    },
    computed: {
      maybeNom () { return this.menu.nom ? `(${this.menu.nom})` : ""; },
      ticket   () { return Menu.price.bind(this)(this.menu); },
      classe   () { return Menu.classe.bind(this)(this.menu); },
    },
    methods:{
      oneCap (s) { return oneCap(s); },
      twoCap (s) { return twoCap(s); },
      getNom     (i) { return i.nom },
      raz        ()  { this.$emit('raz', this.menu.uid); },
      dup        ()  { this.$emit('dup', this.menu.uid); },
      kill       ()  { this.$emit('kill', this.menu.uid); },
      total      ()  { return Menu.price(this.menu)['total']; },
      setc       (k) {
        let uid = this.menu.uid;
        return (nuw) => { this.set({ uid, k, nuw }); };
      },
      setOffert  ()  {
        let uid = this.menu.uid;
        this.set({ uid, k:'offert', nuw:!this.menu.offert });
      },
      setViande (counted, delta) {
        let uid = this.menu.uid;
        this.$emit('setViande', {uid, counted, delta} );
      },
      setBoisson (counted) {
        let uid = this.menu.uid;
        this.$emit('setBoisson', { uid, counted });
      },
    }
}
</script>

<style>
.menu {
    border: thin solid #00f1;
    background-color: lavender;
    transition: border 0.4s ease-out, background-color 0.3s;
    min-width: 23.5em;
}

.menu h3 { width: auto; opacity: 0.75; }

.menu:hover { border: thin solid #00f5; }
.menu:hover h3 { opacity: 1; }

.menu div.header {
    margin: 8px;
    padding: 8px;
}

.header {
    font-size: 10pt;
    font-weight: bold;
}

.menu div.header button {
    float: none;
}

.ops {
position: relative;
}


button[title="kill"] {
position: absolute;
right: 0;
color: deeppink;
font-weight: bold;
}

span.titre {
    cursor: pointer;
    padding: 8px 0;
}

span.titre:hover {
    background-color: rgba(0,0,0,0.1);
}

.ops {
    background-color: #00000014;
    border: thin solid #0900003b;
}

.op {
    border: thin solid lightgray;
}

h3 {
    text-align: center;
    padding: 8px 2px;
}

.modeste { background-color: mintcream; }
.titan { background-color: lemonchiffon; }
.imperial { background-color: oldlace; }
.gwo { background-color: #fbc5fd; }
.beke { background-color: white; }
.ultra { background-color: white; }

.gratuit { 
    background-color: lime;
    color: green;
}

.menu .header.vide {
  color: gray;
}
.menu.gratuit { border: thin solid lightgreen; background-color: lime; color: green; }

.gratuit h3 {
    background: linear-gradient(90deg, rgba(0,255,0,1) 0%, rgba(0,212,255,1) 100%); 
}

input.nom {
padding: 0 4px;
margin: 4px;
border: thin solid lavender;
width: -moz-available;
}

.menu section:nth-child(2n) label {
background-color: #3c3c3c1c; /* #716f6f1c; */
}

.sep {
margin: 0;
padding: 0 4px;
text-align: right;
opacity: 0.5;
border-bottom: thin solid lightgray;
}
</style>
